/* eslint-disable import/prefer-default-export */

export const DEFAULT_MC12 = {
  track: {
    length: 0,
    nbSegments: 0,
    nbStraightSegments: 0,
    nbAngledSegments: 0,
    overallSizeX: 0,
    overallSizeY: 0,
    trackPattern: [],
    isTrackClosed: false,
    canAutoCloseTrack: false,
    shouldShowSnackBarForGuideRailsRecalculation: false,
    shouldRecalculateGuideRails: false,
    calculatedGuideRails: [],
    calculatedElectricalInstallation: {},
    calculatedCommunication: {},
    selectedAccessories: [],
    calculatedCarriers: [],
    calculatedSegments: {},
    shouldRecalculateCommunication: false,
    shouldRecalculateElectricalInstallation: false
  },
  segments: {},
  accessories: [],
  powerSupplies: [],
  backupTrack: null
};
